import React, { PropsWithChildren } from 'react';

export function ReadOnlyField({ name, children }: PropsWithChildren<{ name: string }>): React.ReactElement {
  return (
    <div>
      <div className="caption" style={{ color: 'var(--accent-2)' }}>
        {name}
      </div>
      {children}
    </div>
  );
}
